import HmltToRender from "@/utils/HtmlToRender";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useMemo } from 'react';

const ArticleExcerpt = (props) => {
  const { item, keyName, routeMap, id, text, html } = props;

  const formattedDate = useMemo(() => {
    // Use a fixed locale 'fr-BE' or 'nl-BE' depending on context if available, otherwise fixed for hydration stability
    // Ideally pass lang code, but for now fixed locale is better than random browser default vs server node default
    if (!item?.created?.datetime) return '';
    return new Date(item?.created?.datetime).toLocaleDateString("fr-BE");
  }, [item?.created?.datetime]);

  return (
    <>
      <Excerpt className={`${keyName}__${id}`}>
        <ArticleTitle>
          <Link to={`${routeMap?.urls.articleActuality}/${item.slug}`}>
            {item.title}
          </Link>
        </ArticleTitle>
        <Created>
          {formattedDate}
        </Created>
        <ArticleContentWrapper>
          <img
            src={
              item.media?.thumb ??
              "https://carbucomstatic-5141.kxcdn.com/mazout_com/logo/flamme.jpeg"
            }
            alt={item.media?.alt ?? text?.form.NoImage}
            loading="lazy"
            width={160}
            height={160}
          />
          <ContentArticleWrapper>
            <HmltToRender __html={html.__html} />

            <Readmore>
              <Link to={`${routeMap?.urls.articleActuality}/${item.slug}`}>
                {text?.home.articles.readMore}
              </Link>
            </Readmore>
          </ContentArticleWrapper>
        </ArticleContentWrapper>
      </Excerpt>
    </>
  );
};

export default ArticleExcerpt;

const Created = styled.div.attrs({
  className: "created",
})`
  color: ${(props) => props.theme.colors.blue};
  font-size: 1.4rem;
`;

const ArticleContentWrapper = styled.div.attrs({
  className: "ArticleContentWrapper",
})`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  img {
    flex: 0 0 auto;
    height: auto;
    max-height: 10em;
    margin-right: 1em;
    margin-bottom: 1px;

    opacity: 0.4;
    filter: alpha(opacity=40); /* msie */
    background-color: #000;
  }
  flex-direction: row;

  @container blockquote-container (width < 367px) {
    img {
      display: none;
    }
  }
`;

const Excerpt = styled.blockquote.attrs({
  className: "Excerpt",
})`
  display: flex;
  flex-direction: column;
  container-name: blockquote-container;
  container-type: inline-size;
`;

const ArticleTitle = styled.h2.attrs({
  className: "ArticleTitle",
})`
  font-size: 1.6rem;
  line-height: 1.3;
  font-family: ${(props) => props.theme.fonts.title};
  font-weight: normal;
  color: ${(props) => props.theme.colors.dark};
  @media screen and (min-width: 992px) {
    font-size: 1.8rem;
    min-height: 24px;
    font-size: 2rem;
  }
  text-wrap: pretty;
`;

const Readmore = styled.p.attrs({
  className: "Readmore",
})`
  margin-top: auto;
  padding-top: 12px;

  a {
    color: ${(props) => props.theme.colors.blue} !important;
    text-decoration: underline;
    &:hover {
      color: ${(props) => props.theme.colors.blueDark} !important;
    }
  }
  text-align: right;
`;

const ContentArticleWrapper = styled.div.attrs({
  className: "ContentArticleWrapper",
})`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: space-between;
  @media screen and (min-width: 992px) {
    margin-left: 16px;
  }
`;
